export const RiskBillType = [
    { key: 1, name: '米融探针', color: 'success' },
    { key: 2, name: '米融雷达', color: 'gray' }
]